import * as countries from 'i18n-iso-countries'
import enLocale from 'i18n-iso-countries/langs/en.json'
import deLocale from 'i18n-iso-countries/langs/de.json'

// Register locales for country code conversion
countries.registerLocale(enLocale)
countries.registerLocale(deLocale)

/**
 * Converts ISO2 country code to ISO3 country code
 * @param countryCode - ISO2 country code (e.g., 'DE', 'US', 'GB')
 * @returns ISO3 country code (e.g., 'DEU', 'USA', 'GBR') or 'DEU' as fallback
 */
export const mapCountryCodeToISO3 = (countryCode: string): string => {
    const upperCaseCountryCode = countryCode.toUpperCase()
    return countries.alpha2ToAlpha3(upperCaseCountryCode) || 'DEU'
}
